<template>
  <v-dialog :value="value" max-width="500" @input="$emit('input', $event)">
    <v-card>
      <div class="d-flex justify-space-between align-center pa-3">
        <div class="d-flex align-center" style="gap: 8px">
          <v-icon :color="validation.alertType">
            {{ alertIcon }}
          </v-icon>
          <div>
            <div class="text-subtitle-1 font-weight-bold">Validation Results</div>
          </div>
        </div>
        <v-btn icon small @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <div class="d-flex flex-column" style="gap: 12px">
          <!-- Summary chips -->
          <div class="d-flex" style="gap: 8px">
            <v-chip small color="success" outlined>
              <v-icon small left>mdi-check</v-icon>
              {{ validation.matched }} matched
            </v-chip>
            <v-chip v-if="validation.missingInScan > 0" small color="warning" outlined>
              <v-icon small left>mdi-alert</v-icon>
              {{ validation.missingInScan }} not in scan
            </v-chip>
            <v-chip v-if="validation.missingImages > 0" small color="info" outlined>
              <v-icon small left>mdi-information</v-icon>
              {{ validation.missingImages }} extra in scan
            </v-chip>
          </div>

          <!-- Missing images list -->
          <div v-if="validation.missingInScanNames.length > 0">
            <div class="text-caption grey--text mb-1">Images not found in scan file:</div>
            <div v-if="scanFileName" class="text-caption grey--text text--darken-1 mb-2">
              <v-icon x-small class="mr-1">mdi-file-document-outline</v-icon>
              {{ scanFileName }}
            </div>
            <v-sheet outlined rounded class="pa-0" style="max-height: 250px; overflow-y: auto">
              <v-list dense class="py-0">
                <v-list-item
                  v-for="(name, index) in validation.missingInScanNames"
                  :key="name"
                  dense
                  class="px-3"
                  :class="{ 'border-bottom': index < validation.missingInScanNames.length - 1 }">
                  <v-list-item-icon class="mr-3 my-2">
                    <v-icon small color="warning">mdi-image-off</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-2">
                    <v-list-item-title class="text-body-2">{{ name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-sheet>
          </div>

          <!-- All matched message -->
          <div v-if="validation.missingInScanNames.length === 0" class="text-center py-4">
            <v-icon color="success" x-large>mdi-check-circle-outline</v-icon>
            <div class="text-body-1 mt-2">All selected images found in scan file!</div>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="$emit('input', false)">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * ValidationDialog - Displays detailed validation results for scan file validation
 *
 * Props:
 * - value (Boolean): v-model binding for dialog visibility
 * - validation (Object): Validation result object from validateFilesAgainstScan()
 * - scanFileName (String): Optional name of the scan file for display
 */
export default {
  name: 'ValidationDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      required: true,
      default: () => ({
        matched: 0,
        missingInScan: 0,
        missingImages: 0,
        missingInScanNames: [],
        alertType: 'success',
      }),
    },
    scanFileName: {
      type: String,
      default: '',
    },
  },

  computed: {
    alertIcon() {
      switch (this.validation.alertType) {
        case 'success':
          return 'mdi-check-circle';
        case 'error':
          return 'mdi-close-circle';
        default:
          return 'mdi-alert-circle';
      }
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
